import { PostAttachmentType } from '__generated__/graphql/legacy/graphql';
import { TFunction } from 'next-i18next';
import * as z from 'zod';

const attachment = z.object({
  altText: z.string().optional().nullable(),
  attachmentType: z.nativeEnum(PostAttachmentType),
  attachmentUrl: z.string().optional().nullable(),
  fileName: z.string().optional().nullable(),
  fileSizeInBytes: z.number().optional().nullable(),
  filestackId: z.string().optional(),
  id: z.string().optional(),
  isLoading: z.boolean().optional(),
  s3Bucket: z.string().optional(),
  s3Key: z.string().optional(),
  tempId: z.string().optional(),
  url: z.string().optional().nullable(),
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getAttachmentSchema = () => {
  return attachment;
};

export const getSchema = (tFunc?: TFunction) => {
  const t = tFunc || ((s) => s); // Needed for custom messages
  return z
    .object({
      body: z
        .object({
          jsonContent: z
            .object({
              type: z.literal('doc'),
              content: z.array(z.any()),
              version: z.string(),
            })
            .nullable()
            .refine((data) => !!(!data || data.content?.length > 0), {
              message: t('Post cannot be empty'),
              path: [],
            }),
          plainText: z.string().refine((data) => !!(data && data.trim()), {
            message: t('Post cannot be empty'),
            path: [],
          }),
        })
        .optional(),
      attachments: z.array(attachment),
      mentionedUserIds: z.array(z.string()).optional(),
      parentPostId: z.string().optional(),
      parentReplyId: z.string().optional(),
      numberOfReactions: z.number().optional(),
      content: z.string().optional(),
      discussionableId: z.string(),
    })
    .refine((data) => data.body?.jsonContent?.content?.length || data.body?.plainText?.trim(), {
      message: t('Post cannot be empty'),
      path: [],
    });
};
